import React, {useCallback} from 'react'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {Grid} from '@vio/atlas/helpers/Grid'
import {InputSelect} from '@vio/atlas/InputSelect'
import {cssTheme} from '@vio/atlas/themes'

const AGE_FIELD_SIZES = ['sm', 'lg'] as const

export type AgeFieldSize = (typeof AGE_FIELD_SIZES)[number]

interface Props {
  displayName?: string
  onChange: (value: number) => void
  value: number
  size?: AgeFieldSize
}

interface AgeListItemProps {
  label: string
  value: number
}

const MAX_CHILD_AGE = 18

const getFieldStyle = (size: AgeFieldSize) => {
  return `
    &.size-${size} {
      width: ${size === 'lg' ? '91px' : '62px'};
    }
  `
}

const InputLabelText = styled.div`
  ${cssTheme.typography.bodyS}
`

const InputWrapper = styled.div`
  ${AGE_FIELD_SIZES.map(getFieldStyle).join('')}
`

const getAgeList = (): AgeListItemProps[] => {
  const ageList = [{label: '<1', value: 0}]

  for (let i = 1; i < MAX_CHILD_AGE; i++) {
    ageList.push({label: i.toString(), value: i})
  }

  return ageList
}

export const AgeField = ({
  displayName,
  onChange,
  value,
  size = 'lg'
}: Props) => {
  const handleChange = useCallback(
    (value: string) => {
      onChange(Number(value))
    },
    [onChange]
  )

  const ageList = getAgeList()

  return (
    <Grid container alignItems="center">
      <Grid mobileSm="fill">
        <InputLabelText>{displayName}</InputLabelText>
      </Grid>
      <Grid mobileSm="fit">
        <InputWrapper className={cx(`size-${size}`)}>
          <InputSelect
            value={value.toString()}
            size={size}
            onChange={handleChange}
          >
            {ageList.map((age: AgeListItemProps) => (
              <option key={age.value} value={age.value}>
                {age.label}
              </option>
            ))}
          </InputSelect>
        </InputWrapper>
      </Grid>
    </Grid>
  )
}
